import React from "react";
import "./Partner.css";
import venkatImage from "../../assets/venkat.JPG";

const Partner = () => {
  return (
    <section className="partner-wrapper">
      <h1 className="MainHeading6">50% of Our Clients</h1>
      <h1 className="heading22">Trust Us as a Strategic Partner</h1>

      <div className="partner-container">
        <div className="partner-image">
          <img src={venkatImage} alt="Venkat Vedicharla" />
            <p className="partner-name">
              <strong>Venkat Vedicharla</strong><br className="mobile-break" /> || Managing Director.
            </p>
        </div>

        <div className="partner-content">
          <img
            src="https://th.bing.com/th/id/OIP.O3f04qukAdwJjznhRUvPCgHaHa?w=176&h=180&c=7&r=0&o=5&cb=iwc2&dpr=1.3&pid=1.7"
            alt="Logo"
            className="partner-logo"
          />

          <div className="quote-block">
            <span className="quote-icon">“</span>
            <div className="partner-text">
              <p className="text-gray-700 text-l leading-relaxed max-w-3xl mx-auto">
                At Adithya Infinity, we empower IT professionals through innovation,
                real-time training, and meaningful career-building. Our mission is to
                bridge the gap between industry demands and individual potential,
                ensuring long-term growth and success.
              </p>
              </div>

            <span className="quote-icon end">”</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partner;
